// @ts-nocheck
import angular from "angular"

require("jsonformatter")

function getWatchers(root, debug = false) {
  root = angular.element(root || document.documentElement)
  var watcherCount = 0

  function getElemWatchers(element) {
    var isolateWatchers = getWatchersFromScope(element.data().$isolateScope)
    var scopeWatchers = getWatchersFromScope(element.data().$scope)
    var watchers = scopeWatchers.concat(isolateWatchers)

    //
    !suspendido(element) &&
      angular.forEach(element.children(), function(childElement) {
        watchers = watchers.concat(
          getElemWatchers(angular.element(childElement))
        )
      })

    return watchers
  }

  function activo(scope: ng.IScope) {
    var a = scope && !(scope as any).$$suspended
    // debug && console.log("activo", a, scope)
    return !scope || a
  }

  function suspendido($el) {
    let suspendido = false

    if ($el.data().$isolateScope)
      suspendido = $el.data().$isolateScope.$$suspended

    if (!suspendido && $el.data().$scope)
      suspendido = $el.data().$scope.$$suspended

    if (suspendido && debug) console.log("suspendido", $el)

    return suspendido
  }

  function getWatchersFromScope(scope) {
    if (scope && !scope.$$suspended) {
      return scope.$$watchers || []
    } else {
      return []
    }
  }

  return getElemWatchers(root)
}

export var watchers = (debug = false): any => {
  return getWatchers($("[ng-app]"), debug).length
}

// crear el servicio configuración
export var $uniDebug = angular.module("UniDebug", ["UniBase", "jsonFormatter"])


import "./styles/uni-debug.scss"